import script from "./MainButton.vue?vue&type=script&setup=true&lang=js"
export * from "./MainButton.vue?vue&type=script&setup=true&lang=js"

import "./MainButton.vue?vue&type=style&index=0&id=5740f60e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5740f60e"]])

export default __exports__